import { put, takeLatest, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import {
  createCandidateSuccess,
  createCandidateFailed,
  updateCandidateSuccess,
  CREATE_CANDIDATE,
  UPDATE_CANDIDATE,
  CONFIRM_DETAILS_CANDIDATE,
  WRAP_UP,
} from '../modules/candidate'
import { createCandidate, updateCandidate, confirmDetailsCandidate, completeOnboarding } from '../api'

function* createCandidateSaga({ payload, meta }) {
  try {
    const { first_name, last_name, placeId, recaptchaToken, ...candidate } = payload.candidate
    const response = yield createCandidate(
      {
        name: `${first_name} ${last_name}`,
        place_id: placeId,
        accepted_terms_of_service: true,
        ...candidate,
      },
      recaptchaToken,
    )

    yield call(meta.refetchCurrentUser)
    yield put(createCandidateSuccess(response.data))

    // Trigger GTM Event when candidate signed up
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Candidate Sign Up',
      action: 'sign up completed',
      label: 'candidate sign up',
      category: 'Core',
      source: 'candidate sign up form',
      email: candidate.email,
    })
  } catch (error) {
    yield put(createCandidateFailed(error.response.data.notification))
  }
}

function* updateCandidateSaga({ payload: { candidate, nextRoute } }) {
  const response = yield updateCandidate(candidate)
  yield put(updateCandidateSuccess(response))

  if (nextRoute) yield put(push(nextRoute))
}

function* confirmDetailsCandidateSaga({ payload: { candidate, nextRoute } }) {
  const { first_name, last_name, location, based_in_location, placeId, opt_into_marketing, email } = candidate

  const response = yield confirmDetailsCandidate({
    name: `${first_name} ${last_name}`,
    place_id: placeId,
    based_in_location,
    opt_into_marketing,
    location,
  })
  yield put(updateCandidateSuccess(response))

  // Trigger GTM Event when candidate signed up
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Candidate Sign Up',
    action: 'sign up completed',
    label: 'candidate sign up',
    category: 'Core',
    source: 'candidate sign up form',
    email: email,
  })

  window.location.replace(nextRoute)
}

function* wrapUpCandidateSaga(action) {
  try {
    yield updateCandidate(action.payload.candidate)
    const { candidate } = yield completeOnboarding()

    // Trigger GTM Event when candidate completes onboarding
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Candidate Submit',
      action: 'submitted for review',
      label: 'offerzen core',
      source: 'new submit',
      source_detail: 'candidate onboarding',
    })

    // FIXME: Should use "soft" redirect (e.g. with react router)
    //        but `CandidateExperience/Main.js` uses the data returned by
    //        graphql to redirect to onboarding when the candidate is not yet
    //        `in_review` and, since React Query caches pretty heavily,
    //        the candidateProfile query is not refetched so a hard refresh is
    //        necessary to avoid being redirected back to onboarding.
    window.location.assign(`/candidate/${candidate.slug}/dashboard`)
  } catch (err) {}
}

export function* watchCandidateSaga() {
  yield takeLatest(CREATE_CANDIDATE, createCandidateSaga)
  yield takeLatest(UPDATE_CANDIDATE, updateCandidateSaga)
  yield takeLatest(CONFIRM_DETAILS_CANDIDATE, confirmDetailsCandidateSaga)

  yield takeLatest(WRAP_UP, wrapUpCandidateSaga)
}
